{
  "Clear search": "Wyczyść wyniki wyszukiwania"
}
